import Box from '@mui/material/Box';
import Grid from '@mui/material/GridLegacy';
import Typography from '@mui/material/Typography';
import parse from 'html-react-parser';

interface PropTypes {
  title: string;
  content: string;
}

function SubSection(props: PropTypes): JSX.Element {
  return (
    <Grid item container alignItems={'center'} justifyContent="center" xs={12} md={6}>
      <Box>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
          {props.title}
        </Typography>
        <Typography component="span">{parse(props.content)}</Typography>
      </Box>
    </Grid>
  );
}

export default SubSection;
